import { useDispatch } from 'store/hooks';
import { portfolioSummaryInitialise } from 'widgets/portfolioSummary/store/instances/actions';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useCallback } from 'react';

export const useDispatchPortfolioSummaryInitialise = () => {
    const { widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    return useCallback(() => {
        dispatch(portfolioSummaryInitialise(widgetKey));
    }, [widgetKey, dispatch]);
};
